import React from 'react';
import PropTypes from 'prop-types';
import immJs from 'lodash';
import { Icon, Button, Modal } from 'antd';
import './CalendarButtonComponent.scss';

class CalendarButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      visible: false,
    };
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleOk = this.handleOk.bind(this);
  }

  handleMouseOver() {
    this.setState({
      hover: true,
    });
  }

  handleMouseLeave() {
    this.setState({
      hover: false,
    });
  }

  handleOk() {
    const { revokeAccess, name, refreshCalendar } = this.props;
    revokeAccess(
      {
        Providers: [
          {
            ProviderName: name,
          },
        ],
      },
      refreshCalendar
    );
    this.setState({
      visible: false,
      hover: false,
    });
  }

  handleCancel() {
    this.setState({
      visible: false,
    });
  }

  showModal() {
    this.setState({
      visible: true,
    });
  }

  render() {
    let icons;
    let cssClassName;
    const { name, openProvider, revokeAccess, icon, text } = this.props;
    const { hover, visible } = this.state;
    if (immJs.get(this.props, `externalProviders.${name}.Registered`, false)) {
      cssClassName = 'selected';
      if (!hover) {
        icons = (
          <React.Fragment>
            <Icon type="check-circle" theme="filled" className="check-circle" />
          </React.Fragment>
        );
      } else {
        icons = (
          <React.Fragment>
            <div
              onClick={() => this.showModal()}
              onKeyPress={() => this.showModal()}
              role="button"
              tabIndex={0}
              className="close-circle-button"
            >
              <Icon type="close-circle" theme="filled" className="close-circle" />
            </div>
            <Modal
              title="Are you sure you want to remove the integration?"
              visible={visible}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              closable={false}
              okText="Confirm"
              mask
              width="437px"
              className="revoke-confirm"
            >
              <div className="modal-body">This will remove all the events coming from {name} calendar.</div>
            </Modal>
          </React.Fragment>
        );
      }
    } else {
      icons = null;
    }
    return (
      <Button
        className={`calendar-button ${cssClassName}`}
        onClick={() => openProvider(name, revokeAccess)}
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
        onFocus={() => this.handleMouseOver}
      >
        {icon} {text} {icons}
      </Button>
    );
  }
}

export default CalendarButton;

CalendarButton.propTypes = {
  revokeAccess: PropTypes.func.isRequired,
  openProvider: PropTypes.func.isRequired,
  refreshCalendar: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  externalProviders: PropTypes.shape({}),
};

CalendarButton.defaultProps = {
  externalProviders: {},
};
